import * as React from "react";
import { cn } from "@/lib/utils";

const JeaCard = React.forwardRef(({ className, elevated = false, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "bg-bg-secondary border border-border-default rounded-[12px] p-6",
      elevated ? "shadow-elevated" : "shadow-card",
      className
    )}
    {...props}
  />
));
JeaCard.displayName = "JeaCard";

export { JeaCard };
export default JeaCard;
